import React from "react";
import "./IntroStaff.css";
import FadeUp from "../FadeUp/FadeUp";

const IntroStaff = ({ isAlbanian }) => {
  return (
    <div>
      <div className="introstaff-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="introstaff-content">
            <div className="introstaff-right">
              <h2>
              <FadeUp>
                {(isAlbanian
                  ? `Ambienti në Vila-L është i plotësuar. Ekipi është shumë bashkëpunues dhe komunikimi është shumë i mirë. Çdo punonjës është i përkushtuar për të ofruar shërbimin më të mirë për klientët—gjithmonë profesional, korrekt, i përpiktë dhe i dobishëm. Mjedisi i punës është pozitiv dhe mbështetës, i karakterizuar nga harmonia dhe respekti i ndërsjellë midis kolegëve.`
                  : `Life at Vila-L is fulfilling. The team is highly cooperative, and communication flows smoothly. Every employee is dedicated to delivering the best service for clients—always professional, punctual, helpful, and hardworking. The working environment is positive and supportive, defined by harmony and mutual respect amongst collages.`
                )
                  .split("\n")
                  .map((text, index) => (
                    <span key={index}>
                      {text}
                      <br />
                    </span>
                  ))}
                  </FadeUp>
              </h2>
            </div>
            <div className="introstaff-left">
              <div
                className="introstaff-title"
              >
                <FadeUp>
                {isAlbanian ? "Ambienti në Vila-L " : "Life at Vila-L"}
                </FadeUp>
              </div>
            </div>
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
    </div>
  );
};

export default IntroStaff;
